
export type StepActionType = typeof StepActionType[keyof typeof StepActionType];


export const StepActionType = {
  FileUpload: 'FileUpload',
  FileDownload: 'FileDownload',
  EditCompanyData: 'EditCompanyData',
  ViewCompanyData: 'ViewCompanyData',
  SignContractLink: 'SignContractLink',
  DownloadContract: 'DownloadContract',
  MyDokaLink: 'MyDokaLink',
  OnlineShopLink: 'OnlineShopLink',
  InsertCompanyData: 'InsertCompanyData',
  ActivateMyDoka: 'ActivateMyDoka',
} as const;
